// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

function jsExnToMessage(error) {
  return Relude_Option.getOrElse("EMPTY JS EXCEPTION MESSAGE PROPERTY", error.message);
}

function sToT(message) {
  if (typeof message === "number") {
    switch (message) {
      case /* InitState */0 :
          return {
                  message: "InitState",
                  graphqlErrors: undefined,
                  networkError: undefined
                };
      case /* InLoadingState */1 :
          return {
                  message: "InLoadingState",
                  graphqlErrors: undefined,
                  networkError: undefined
                };
      case /* EmptyData */2 :
          return {
                  message: "EmptyData",
                  graphqlErrors: undefined,
                  networkError: undefined
                };
      case /* DecodeError */3 :
          return {
                  message: "DecodeError",
                  graphqlErrors: undefined,
                  networkError: undefined
                };
      case /* NetworkError */4 :
          return {
                  message: "NetworkError",
                  graphqlErrors: undefined,
                  networkError: undefined
                };
      
    }
  } else {
    switch (message.TAG | 0) {
      case /* GraphQLError */0 :
          return {
                  message: message.message,
                  graphqlErrors: message.graphqlErrors,
                  networkError: message.networkError
                };
      case /* ParseError */2 :
          return {
                  message: "ParseError: " + Relude_Option.getOrElse("EMPTY JS EXCEPTION MESSAGE PROPERTY", message._0.message),
                  graphqlErrors: undefined,
                  networkError: undefined
                };
      case /* ResponseError */1 :
      case /* UnknownError */3 :
          return {
                  message: message._0,
                  graphqlErrors: undefined,
                  networkError: undefined
                };
      
    }
  }
}

var partial_arg = Curry._2(Relude_Array.foldLeft, (function (init, s) {
        return init + ("; " + s);
      }), "");

var partial_arg$1 = [];

function partial_arg$2(param) {
  return Relude_Option.getOrElse(partial_arg$1, param);
}

function optionArrayStringToString(param) {
  return Relude_Globals.$great$great(partial_arg$2, partial_arg, param);
}

function errorToString(message) {
  if (typeof message === "number") {
    switch (message) {
      case /* InitState */0 :
          return "InitState";
      case /* InLoadingState */1 :
          return "InLoadingState";
      case /* EmptyData */2 :
          return "EmptyData";
      case /* DecodeError */3 :
          return "DecodeError";
      case /* NetworkError */4 :
          return "NetworkError";
      
    }
  } else {
    switch (message.TAG | 0) {
      case /* GraphQLError */0 :
          return "GraphQLError:: message: " + (message.message + ("; graphqlErrors: " + (optionArrayStringToString(message.graphqlErrors) + ("; networkError: " + Relude_Option.getOrElse("", message.networkError)))));
      case /* ResponseError */1 :
          return "ResponseError: " + message._0;
      case /* ParseError */2 :
          return "ParseError: " + Relude_Option.getOrElse("EMPTY JS EXCEPTION MESSAGE PROPERTY", message._0.message);
      case /* UnknownError */3 :
          return "UnknownError: " + message._0;
      
    }
  }
}

exports.jsExnToMessage = jsExnToMessage;
exports.sToT = sToT;
exports.optionArrayStringToString = optionArrayStringToString;
exports.errorToString = errorToString;
/* partial_arg Not a pure module */
